export default __webpack_public_path__ + "static/media/elo.2ed6580e.svg";